import { GridColDef } from '@microservices/wiskey-react-table-component'
import { MobileForm } from '@mobileTypes'

export const MOBILE_FORMS_COLUMNS: GridColDef[] = [
  {
    field: 'internalId',
    headerName: 'Internal ID',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 200,
  },
]

export const DEFAULT_MOBILE_FORM: Omit<MobileForm, 'id' | 'createdAt' | 'updatedAt'> = {
  internalId: '',
  name: '',
  objectCode: '',
  fieldDataVariable: undefined,
  elements: [],
  bottomElements: [],
  variables: [],
  eventFlows: [],
}

export const FORM_ELEMENT_TYPES = [
  { value: 'FIELD', label: 'Field' },
  { value: 'PHONE_NUMBER', label: 'Phone Number' },
  { value: 'DIVIDER', label: 'Divider' },
  { value: 'TITLE', label: 'Title' },
  { value: 'BUTTON', label: 'Button' },
  { value: 'SWIPE', label: 'Swipe' },
  { value: 'EMBEDDED_LIST', label: 'Embedded List' },
  { value: 'LIST_ITEM', label: 'List Item' },
  { value: 'ACCORDION', label: 'Accordion' },
  { value: 'FILE', label: 'File' },
]
